module.exports = __webpack_public_path__ + "img/paymi-logo-white-new.281c0d03.png";